module.exports = __webpack_public_path__ + "img/slidebar-bg.70655e79.png";